import {FormattedMessage} from "react-intl";
import React from "react";
import {baseStyles, withMultipleStyles} from "src/styles/Styles";
import TextView from "src/js/components/commons/TextView";
import {ColorSecondary} from "src/styles/Colors";

const MediaPlaceholder = ({labelId, required}) => {

  return (
    <TextView align={'left'} variant="caption" color={ColorSecondary} style={{marginBottom: 4}}>
      <FormattedMessage id={labelId}/>
      {required ? ' * ' : null}
    </TextView>
  );
};

export default (withMultipleStyles(baseStyles))(MediaPlaceholder);
